import { useCohort, useNewUser } from "@/components/user-context";
import { experiments, useExperiment } from "@/utils/experiment";

import { CurrentProductJoinableUser } from "./current-product-joinable-user";
import { CurrentProductUser } from "./current-product-user";
import { ExistingUser } from "./existing-user";
import { NewUser } from "./new-user";

export const LoggedInConfluenceFree = () => {
    const isNewUser = useNewUser();

    const experiment = useExperiment(
        experiments.confluenceContactAndCompanyExpandSiteActivation
    );

    const useContactExpandCohortLogic =
        experiment.type === "enrolled" && experiment.value;

    const cohort = useCohort(useContactExpandCohortLogic);

    if (useContactExpandCohortLogic) {
        if (cohort === "current-product-user") {
            return <CurrentProductUser />;
        }

        if (cohort === "current-product-joinable-user") {
            return <CurrentProductJoinableUser />;
        }
    }

    if (isNewUser) {
        return <NewUser />;
    }

    return <ExistingUser />;
};
